/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CopyInputs */

const en_copy = /** @type {(inputs: CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const fr_copy = /** @type {(inputs: CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier`)
};

const de_copy = /** @type {(inputs: CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopie`)
};

const it_copy = /** @type {(inputs: CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia`)
};

const ru_copy = /** @type {(inputs: CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копия`)
};

const es_copy = /** @type {(inputs: CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const zh_cn2_copy = /** @type {(inputs: CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制`)
};

const ja_copy = /** @type {(inputs: CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピー`)
};

const hi_copy = /** @type {(inputs: CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलिपि`)
};

const pt_pt2_copy = /** @type {(inputs: CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cópia`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {CopyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy = /** @type {((inputs?: CopyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CopyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_copy(inputs)
	if (locale === "de") return de_copy(inputs)
	if (locale === "it") return it_copy(inputs)
	if (locale === "ru") return ru_copy(inputs)
	if (locale === "es") return es_copy(inputs)
	if (locale === "zh-CN") return zh_cn2_copy(inputs)
	if (locale === "ja") return ja_copy(inputs)
	if (locale === "hi") return hi_copy(inputs)
	if (locale === "pt-PT") return pt_pt2_copy(inputs)
	return en_copy(inputs)
});